var _a, _b;
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Button } from "../../../button/src";
import { CATEGORIES, FontAwesomeIcon } from "../../../font-awesome-icon/src";
import { primaryShadow } from "../../../theme/src";
const ariaLabelPrevPage = ((_a = window === null || window === void 0 ? void 0 : window.s__) === null || _a === void 0 ? void 0 : _a.call(window, 'Accessibility|Display previous results')) ||
    'Display previous results';
const ariaLabelNextPage = ((_b = window === null || window === void 0 ? void 0 : window.s__) === null || _b === void 0 ? void 0 : _b.call(window, 'Accessibility|Display next results')) || 'Display next results';
export const SliderArrow = ({ isPrev, onClick, }) => isPrev ? (_jsx(StyledButton, { "aria-label": ariaLabelPrevPage, icon: () => (_jsx(FontAwesomeIcon, { iconName: "angle-left", iconType: CATEGORIES.LIGHT })), onClick: onClick, variant: "inversed" })) : (_jsx(StyledButton, { "aria-label": ariaLabelNextPage, dataTestId: "slider-arrow-next", icon: () => (_jsx(FontAwesomeIcon, { iconName: "angle-right", iconType: CATEGORIES.LIGHT })), onClick: onClick, variant: "inversed" }));
const StyledButton = styled(Button) `
  ${primaryShadow}
  pointer-events: auto;
  border-radius: 20px !important;
  height: 40px;
  width: 40px;
`;
//# sourceMappingURL=SliderArrow.js.map